export function cssVar(v: string) {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(v)
}
